import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachTatCaQuyen: [],
  danhSachQuyenTrongAppPaging: [],
  danhSachTatCaQuyenTrongApp: [],
  danhSachQuyenKhongThuocVaiTro: [],
  danhSachQuyenTheoVaiTro: [],
  danhSachQuyenKhongThuocGroup: []
};
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
